// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//引入公共样式
import './assets/css/global.css'
//导入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import baseUrl from './request/api/base';
Vue.prototype.$baseUrl = baseUrl; // 将api挂载到vue的原型上复制代码

//引入自定义http  api
// import api from './request/api/index'
import api from './request/index'
Vue.prototype.$api = api; // 将api挂载到vue的原型上复制代码

import axios from "axios";
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
//引入vuex
import store from './store'//vuex-store状态管理
//引入富文本编辑器
import quillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(quillEditor)

//富文本图片拖拽缩放
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

//富文本扩展图片上传到服务器
import {ImageExtend, QuillWatch} from 'quill-image-extend-module'
Quill.register('modules/ImageExtend', ImageExtend)

// main.js
import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;  // 在页面里可直接用 this.$cookie 调用
//视频播放组件
import  Video from 'video.js';
import 'video.js/dist/video-js.css';
Vue.prototype.$video=Video;//引入video

//通用loading调用方法-调用this.$withLoading(方法名)()  注意后方的小括号不能少
import {withLoading} from "./mixins/LoadingMixIn.js"
Vue.prototype.$withLoading = withLoading; // 挂载到vue的原型上复制代码

Vue.prototype.$ELEMENT = { size: 'mini' };

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js